import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    is_failure: false,
}

const detailCollectionSlice = createSlice({
    name:"detailCollection",
    initialState: initialState,
    reducers: {
        getDetailCollection(state, action){
            return {
                isLoading: true,
                is_failure: false,
            }
        },
        getDetailCollectionSuccess(state, action){
            return {
                isLoading: false,
                is_failure: false,
                ...action.payload
            }
        },
        getDetailCollectionFailure(state, action){
            return {
                isLoading: false,
                is_failure: true,
            }
        },
        cleanDetailCollection(state, action){
            return {
                isLoading: false,
                is_failure: false,
            }
        }
    }
})

export const { cleanDetailCollection, getDetailCollection, getDetailCollectionFailure, getDetailCollectionSuccess } = detailCollectionSlice.actions

export default detailCollectionSlice.reducer